import { AI_COLUMN_ROW_CREDITS } from "@signalist/shared-types";

import { EmbeddedCreditCost, useEmbeddedCreditCost } from "@/components/CreditConfirmModal";
import { AiApplyType } from "@/enum/list.enum";
import { listSelector } from "@/pages/Private/redux/list/list.slice";
import { useAppSelector } from "@/redux/hooks";

import { CustomColumnApplyFilters } from "../customColumnApplyFilters";
import { aiColumnRunScope } from "./customColumnRunScope";

interface AiColumnRunCostParams {
	open: boolean;
	applyTo: AiApplyType;
	selectedProspectIds?: number[];
	filters?: CustomColumnApplyFilters;
}

/**
 * The AI column form's cost block (PREC-4263): the rows its Apply-to choice runs on, read from the
 * table the form submits from and resolved like the run resolves them (`aiColumnRunScope`, S1).
 */
export function useAiColumnRunCost({
	open,
	applyTo,
	selectedProspectIds,
	filters,
}: AiColumnRunCostParams): EmbeddedCreditCost {
	const { inbox, meta } = useAppSelector(listSelector);

	return useEmbeddedCreditCost({
		active: open,
		scope: aiColumnRunScope({
			applyTo,
			loadedRowCount: inbox.length,
			selectedCount: selectedProspectIds?.length ?? 0,
			viewCount: meta?.itemCount ?? 0,
			hasFilters: !!filters,
		}),
		unitCredits: AI_COLUMN_ROW_CREDITS,
		copy: "aiColumn",
	});
}
